import { useTrackmanEventsEditorStore } from 'stores/Admin/Editors/TrackmanEventsEditorStore';
import { TitleInput } from '../TitleInput/TitleInput';
import { UrlInput } from '../UrlInput/UrlInput';
import { LocationSettings } from '../LocationSettings/LocationSettings';
import { DateAndTimeSettings } from '../DateAndTimeSettings/DateAndTimeSettings';
import { MembershipRequired } from '../MembershipRequired/MembershipRequired';
import { EventVisibility } from '../EventVisibility/EventVisibility';
import { PlayerType } from '../PlayerType/PlayerType';
import { RecordingSettings } from '../RecordingSettings/RecordingSettings';
import { VideoLength } from '../VideoLength/VideoLength';
import { Paragraph } from 'components/TextComps/Paragraph';
import { EventPreview } from '../EventPreview/EventPreview';
import { useState } from 'react';

export const EventEditorForm = () => {
  const {
    title,
    setTitle,
    meetingUrl,
    setMeetingUrl,
    location,
    setLocation,
    locationType,
    setLocationType,
    startDate,
    setStartDate,
    recordingReady,
    setRecordingReady,
    videoId,
    setVideoId,
    videoUrl,
    setVideoUrl,
    visible,
    setVisible,
    videoLengthHours,
    setVideoLengthHours,
    videoLengthMinutes,
    setVideoLengthMinutes,
    videoUploadOption,
    setVideoUploadOption,
    previewImageData,
    setPreviewImageData,
    premiumEvent,
    setPremiumEvent,
    playerType,
    setPlayerType,
  } = useTrackmanEventsEditorStore();

  const [hasFormError, setHasFormError] = useState(false);

  return (
    <div className='edit-event-columns'>
      <div className='edit-event-column left-column'>
        <TitleInput title={title} setTitle={setTitle} />

        <UrlInput
          locationType={locationType}
          meetingUrl={meetingUrl}
          setHasFormError={setHasFormError}
          setMeetingUrlValue={setMeetingUrl}
          error={hasFormError}
        />

        <LocationSettings locationType={locationType} setLocationType={setLocationType} location={location} setLocation={setLocation} />
        <DateAndTimeSettings startDate={startDate} setStartDate={setStartDate} />
        <MembershipRequired isPremiumEvent={premiumEvent} setPremiumEvent={setPremiumEvent} />
        <EventVisibility
          visible={visible}
          isRecordingReady={recordingReady}
          setVisible={setVisible}
          setIsRecordingReady={setRecordingReady}
          setVideoId={setVideoId}
          setVideoUrl={setVideoUrl}
          setVideoLengthHours={setVideoLengthHours}
          setVideoLengthMinutes={setVideoLengthMinutes}
          setPreviewImageData={setPreviewImageData}
        />

        {recordingReady && (
          <>
            <PlayerType playerType={playerType} setPlayerType={setPlayerType} />
            <RecordingSettings
              videoUploadOption={videoUploadOption}
              videoId={videoId}
              videoUrl={videoUrl}
              setVideoUploadOption={setVideoUploadOption}
              setVideoId={setVideoId}
              setVideoUrl={setVideoUrl}
              setPreviewImageData={setPreviewImageData}
            />
            <VideoLength
              videoLengthHours={videoLengthHours}
              videoLengthMinutes={videoLengthMinutes}
              setVideoLengthHours={setVideoLengthHours}
              setVideoLengthMinutes={setVideoLengthMinutes}
            />
          </>
        )}
        <div className='admin-edit-section'>
          <Paragraph>
            <>* required field</>
          </Paragraph>
        </div>
      </div>
      <div className='edit-event-column right-column'>
        <EventPreview
          videoId={videoId}
          isPremiumEvent={premiumEvent}
          videoLengthHours={videoLengthHours}
          videoLengthMinutes={videoLengthMinutes}
          title={title}
          startDate={startDate}
          recordingReady={recordingReady}
          locationType={locationType}
          location={location}
          playerType={playerType}
          previewImageData={previewImageData}
          setPreviewImageData={setPreviewImageData}
        />
      </div>
    </div>
  );
};
